import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=912a8fbc&scoped=true"
import script from "./TeacherDetail.vue?vue&type=script&lang=js"
export * from "./TeacherDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&id=912a8fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a8fbc",
  null
  
)

export default component.exports